export const getDoneViewStyles = () => ({
  doneView: {
    marginLeft: '26px',
    marginBottom: '12px',

    '& .browser-extension-icon': {
      marginTop: '20px',
      marginBottom: '20px',
    },
  },
});
